import { Link } from "react-router-dom";
import { allMovies, allNews } from "@/utils/media";

const entries = [
  {
    to: "/category/movie",
    icon: "ri-film-line",
    title: "电影",
    desc: "院线热片、口碑佳作一站浏览",
    accent: "bg-primary-500",
  },
  {
    to: "/category/tv",
    icon: "ri-tv-2-line",
    title: "电视剧",
    desc: "热播剧集、年代大戏持续更新",
    accent: "bg-accent-500",
  },
  {
    to: "/news",
    icon: "ri-newspaper-line",
    title: "影视资讯",
    desc: "行业动态、剧集观察与影评推荐",
    accent: "bg-secondary-500",
  },
];

export default function CategoryEntries() {
  const counts: Record<string, number> = {
    "/category/movie": allMovies.filter((item) => item.type === "movie").length,
    "/category/tv": allMovies.filter((item) => item.type === "tv").length,
    "/news": allNews.length,
  };

  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 pt-10 md:px-8 md:pt-12">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 md:gap-5">
        {entries.map((entry) => (
          <Link
            key={entry.to}
            to={entry.to}
            className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-all hover:border-primary-300"
          >
            <span
              className={`flex h-14 w-14 shrink-0 items-center justify-center rounded-lg ${entry.accent} text-background-50 transition-transform group-hover:scale-105`}
            >
              <i className={`${entry.icon} text-2xl`}></i>
            </span>
            <div className="min-w-0">
              <div className="flex items-center gap-2">
                <h3 className="text-base font-bold text-foreground-950">{entry.title}</h3>
                <span className="rounded-full bg-background-100 px-2 py-0.5 text-xs text-foreground-500">
                  {counts[entry.to]} 部
                </span>
              </div>
              <p className="mt-1 truncate text-sm text-foreground-500">{entry.desc}</p>
            </div>
            <i className="ri-arrow-right-line ml-auto text-xl text-foreground-300 transition-colors group-hover:text-primary-500"></i>
          </Link>
        ))}
      </div>
    </section>
  );
}